import { ChangeEvent } from 'react';
import Grid from '@mui/material/Grid';
import DeleteIcon from '@mui/icons-material/Delete';
import CustomTextField from '../../../../../../components/CustomTextInput';
import { TransformedItems } from '../../../tradeDocumentTypes/CommercialTypes';

export interface certificateoforiginfieldProps {
    id: string | number;
    updateQuoteField: (
        index: number,
        attributeName: keyof TransformedItems,
        attributeValue: TransformedItems[keyof TransformedItems]
    ) => void;
    index: number;
    removeQuoteField: (index: number) => void;
    item?: TransformedItems;
}

const Certificateoforiginfield = ({
    id,
    updateQuoteField,
    index,
    removeQuoteField,
    item
}: certificateoforiginfieldProps) => {
    return (
        <div className='relative custom-certificateoforiginfield-field'>
            <Grid container>
                <Grid item xs={12} md={12} lg={6}>
                    <div className='lg:border lg:border-appcolorgreyfaint lg:px-[1.5rem] lg:pt-[1.1rem] lg:pb-4 lg:h-full'>
                        <Grid
                            container
                            spacing={1}
                            sx={{
                                marginTop: '0px'
                            }}
                        >
                            <Grid item xs={12} md={12} lg={4}>
                                <CustomTextField
                                    id={`certificateoforiginfield-productCode-${id}`}
                                    label='Marks & Numbers'
                                    name='productCode'
                                    onChange={(
                                        e: ChangeEvent<HTMLInputElement>
                                    ) => {
                                        updateQuoteField(
                                            index,
                                            'productCode',
                                            e.target.value
                                        );
                                    }}
                                    value={item?.productCode}
                                />
                            </Grid>
                            <Grid item xs={12} md={12} lg={8}>
                                <div className='mt-4 lg:mt-0'>
                                    <CustomTextField
                                        required
                                        id={`certificateoforiginfield-desc-${id}`}
                                        label='Description of Goods'
                                        name='desc'
                                        value={item?.desc}
                                        onChange={(
                                            e: ChangeEvent<HTMLInputElement>
                                        ) => {
                                            updateQuoteField(
                                                index,
                                                'desc',
                                                e.target.value
                                            );
                                        }}
                                    />
                                </div>
                            </Grid>
                        </Grid>
                    </div>
                </Grid>

                <Grid item xs={12} md={12} lg={6}>
                    <div className='lg:border lg:border-appcolorgreyfaint lg:px-[1.5rem] lg:pt-[1.1rem] lg:pb-4'>
                        <Grid
                            container
                            spacing={1}
                            sx={{
                                marginTop: '0px'
                            }}
                        >
                            <Grid item xs={12} md={12} lg={6}>
                                <div className='mt-4 lg:mt-0'>
                                    <CustomTextField
                                        value={item?.kindOfPackage}
                                        id={`certificateoforiginfield-kindOfPackage-${id}`}
                                        label='Package Kind'
                                        name='kindOfPackage'
                                        onChange={(
                                            e: ChangeEvent<HTMLInputElement>
                                        ) => {
                                            updateQuoteField(
                                                index,
                                                'kindOfPackage',
                                                e.target.value
                                            );
                                        }}
                                    />
                                </div>
                            </Grid>

                            <Grid item xs={12} md={12} lg={6}>
                                <div className='mt-4 lg:mt-0'>
                                    <CustomTextField
                                        id={`certificateoforiginfield-qtyOfPackage-${id}`}
                                        label='Package Qty'
                                        name='qtyOfPackage'
                                        value={item?.qtyOfPackage}
                                        onChange={(
                                            e: ChangeEvent<HTMLInputElement>
                                        ) => {
                                            updateQuoteField(
                                                index,
                                                'qtyOfPackage',
                                                e.target.value
                                            );
                                        }}
                                    />
                                </div>
                            </Grid>

                            <Grid item xs={12} md={12} lg={6}>
                                <div className='mt-4 '>
                                    <CustomTextField
                                        id={`certificateoforiginfield-tariffCode-${id}`}
                                        label='Tariff Code'
                                        name='tariffCode'
                                        value={item?.tariffCode}
                                        onChange={(
                                            e: ChangeEvent<HTMLInputElement>
                                        ) => {
                                            updateQuoteField(
                                                index,
                                                'tariffCode',
                                                e.target.value
                                            );
                                        }}
                                    />
                                </div>
                            </Grid>

                            <Grid item xs={12} md={12} lg={6}>
                                <div className='mt-4'>
                                    <CustomTextField
                                        id={`certificateoforiginfield-grossWeight-${id}`}
                                        label='Gross Weight (kg)'
                                        name='grossWeight'
                                        value={item?.grossWeight}
                                        onChange={(
                                            e: ChangeEvent<HTMLInputElement>
                                        ) => {
                                            updateQuoteField(
                                                index,
                                                'grossWeight',
                                                e.target.value
                                            );
                                        }}
                                    />
                                </div>
                            </Grid>
                        </Grid>
                    </div>
                </Grid>
            </Grid>

            {index !== 0 && (
                <div
                    className='absolute top-[1.5rem] cursor-pointer right-[0.8rem] custom-certificateoforiginfield-field-delete w-fit transition-all delay-75'
                    onClick={() => {
                        removeQuoteField(index);
                    }}
                >
                    <DeleteIcon />
                </div>
            )}

            <div className='border border-gray300 border-dashed mt-4 lg:mt-0 lg:border-none' />
        </div>
    );
};

export default Certificateoforiginfield;
